const API_URL = "https://api.pxqconsultora.com:3000/"
// const API_URL = "https://www.codice.dev:3004"

export const PrimaryDark_ = '#1A202C'
export const PrimaryLight_ = '#F7FAFC'

export default API_URL

